export const get_eid = {
  methods: {
    get_eid: function(eid){
      eid = eid.split(":")[0];
      var mod_less_eid = eid.substr(0, 2) + "xx" + eid.substr(4);
      // enは必ず存在するはず
      if(this.$i18n.messages.en.error[eid]){
        return eid;
      }else if(this.$i18n.messages.en.error[mod_less_eid]){
        return mod_less_eid;
      }else{
        return "E1xx901";
      }
    },
    replace_param: function(eid, param){
      if(eid.startsWith("E2") && ["251", "256"].indexOf(eid.split(":")[0].slice(-3)) >= 0){
        var target = param.target;
        switch(param.type){
          case "domain":
          case "purpose":
          case "option":
            target = this.$i18n.t("message.common." + param.type + "_" + param.target);
            break;
        }
        return {
          type: this.$i18n.t("message.common." + param.type),
          target: target
        }
      }else if(eid.startsWith("E2") && ["06226"].indexOf(eid.split(":")[0].slice(-5)) >= 0){
        var target1_key = param.target1_key; // string
        var target2_key = param.target2_key; // string
        var target2_key_prefix; // string "domain_","purpose_","option_"のどれか
        var target1_detail = param.target1_detail; // string
        var target2_required = param.target2_required; // array

        switch(param.target1_key){
          case "allowed_domains":
          case "allowed_purposes":
          case "allowed_options":
            target1_key = this.$i18n.t("message.common." + param.target1_key);
            break;
        }
        
        switch(param.target2_key){
          case "allowed_domains":
            target2_key_prefix = "domain_";
            target2_key = this.$i18n.t("message.common." + param.target2_key);
            break;
          case "allowed_purposes":
            target2_key_prefix = "purpose_";
            target2_key = this.$i18n.t("message.common." + param.target2_key);
            break;
          case "allowed_options":
            target2_key_prefix = "option_";
            target2_key = this.$i18n.t("message.common." + param.target2_key);            
            break;
        }

        if(param.target1_key === "allowed_domains"){
          switch(param.target1_detail){
            case "t-3mt":
            case "the-reading":
              target1_detail = this.$i18n.t("message.common.domain_" + param.target1_detail);
              break;
          }
        }else if(param.target1_key === "allowed_purposes"){
          switch(param.target1_detail){
            case "standard":
            case "demo":
            case "tmc":
              target1_detail = this.$i18n.t("message.common.purpose_" + param.target1_detail);
              break;
          }
        }else{
          switch(param.target1_detail){
            case "develop":
            case "option1":
            case "in-company":
              target1_detail = this.$i18n.t("message.common.option_" + param.target1_detail);
              break;
          }
        }
        
        for (let i = 0; i < param.target2_required.length; i++) {
          console.log(param.target2_required[i]);
          if(i===0){
            target2_required =  this.$i18n.t("message.common." + target2_key_prefix + param.target2_required[i]);
          }else{
            target2_required += "," + this.$i18n.t("message.common." + target2_key_prefix + param.target2_required[i]);
          }
        }

        return {
          target1_key: target1_key,
          target2_key: target2_key,
          target1_detail: target1_detail,
          target2_required: target2_required
        }
      }else if(eid.startsWith("E2") && ["217", "218", "253", "254"].indexOf(eid.split(":")[0].slice(-3)) >= 0){
        return {
          layer: this.$i18n.t("message.limit_usage.layer_" + param.layer),
          resource: this.$i18n.t("message.limit_usage.resource_" + param.resource)
        }
      }else if(eid.split(":")[0] === "E201238"){
        return {
          option: this.$i18n.t("message.common.option_" + param.option),
          resource: this.$i18n.t("message.common." + param.resource)
        }
      }else if(eid.split(":")[0] === "E206225" && param.resource === "option2"){
        return {
          resource: this.$i18n.t("message.common.option_" + param.resource)
        }
      }else if(eid.startsWith("E1") && eid.split(":")[0].slice(-3) === "105"){
        return {
          source_lang: this.$i18n.t("message.common.lang_" + param.source_lang),
          target_lang: this.$i18n.t("message.common.lang_" + param.target_lang)
        }
      }else if(eid.split(":")[0] === "E187112"){
        return {
          message: this.$i18n.t("error." + this.get_eid(param.message.eid), this.replace_param(param.message.eid, param.message.param))
        }
      }else if(eid.startsWith("E5")){
        if(["001", "101"].indexOf(eid.split(":")[0].slice(-3)) >= 0){
          return {
            type: this.$i18n.t("message.job.job_type_" + param.type),
            title: param.title.length > 20 ? param.title.substr(0, 20) + "..." : param.title,
            jid: param.jid
          }
        }else if(eid.split(":")[0].slice(-3) === "102"){
          return {
            type: this.$i18n.t("message.job.job_type_" + param.type),
            title: param.title.length > 20 ? param.title.substr(0, 20) + "..." : param.title,
            jid: param.jid,
            progress: param.progress
          }
        }else{
          return param;
        }
      }else{
        return param;
      }
    }
  }
}
